import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SERVICES } from "@/lib/services-catalog";

export const Route = createFileRoute("/categories")({
  head: () => ({
    meta: [
      { title: "All services — Peopels" },
      { name: "description", content: "Every Peopels service across Greater London — handyman, TV mounting, furniture assembly, IKEA assembly, moving help, furniture removal, picture hanging, drywall repair and more." },
      { property: "og:title", content: "All services — Peopels" },
      { property: "og:description", content: "Vetted local professionals across Greater London for handyman, assembly, mounting, moving and home repair services." },
      { property: "og:url", content: "/categories" },
    ],
    links: [{ rel: "canonical", href: "/categories" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "Peopels service categories",
          itemListElement: SERVICES.map((s, i) => ({
            "@type": "ListItem",
            position: i + 1,
            item: {
              "@type": "Service",
              name: s.name,
              serviceType: s.name,
              areaServed: { "@type": "AdministrativeArea", name: "Greater London" },
              provider: { "@type": "Organization", name: "Peopels" },
              url: `/services/${s.slug}`,
            },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "/" },
            { "@type": "ListItem", position: 2, name: "Services", item: "/categories" },
          ],
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main id="main-content" className="mx-auto w-full max-w-7xl flex-1 px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-bold">All services</h1>
        <p className="mt-2 max-w-2xl text-muted-foreground">
          Vetted local professionals across every Greater London postcode. Browse a service to see what's included, typical rates and FAQs.
        </p>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <Link
              key={s.slug}
              to="/services/$slug"
              params={{ slug: s.slug }}
              className="group rounded-2xl border border-border bg-card p-5 transition hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-card"
            >
              <p className="font-semibold group-hover:text-primary">{s.name}</p>
              <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{s.summary}</p>
              <p className="mt-3 text-xs text-muted-foreground">From £{s.rateLow}/hr</p>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
